import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const JobsPage = lazy(() => import('../pages/jobs/page'));
const JobDetailPage = lazy(() => import('../pages/job-detail/page'));
const EmployersPage = lazy(() => import('../pages/employers/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterCandidatePage = lazy(() => import('../pages/auth/register-candidate/page'));
const RegisterEmployerPage = lazy(() => import('../pages/auth/register-employer/page'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password/page'));
const CandidateRegisterPage = lazy(() => import('../pages/candidate-register/page'));
const CandidateDashboardPage = lazy(() => import('../pages/candidate-dashboard/page'));
const EmployerDashboardPage = lazy(() => import('../pages/employer-dashboard/page'));
const InternationalRecruitmentPage = lazy(() => import('../pages/international-recruitment/page'));
const BranchesPage = lazy(() => import('../pages/branches/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/connexion/page'));
const JobApplyPage = lazy(() => import('../pages/job-apply/page'));
const AeronautiquePage = lazy(() => import('../pages/aeronautique/page'));
const AdminCollabPage = lazy(() => import('../pages/admin-collab/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArticlePage = lazy(() => import('../pages/blog/article/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/offres',
    element: <JobsPage />
  },
  {
    path: '/offre/:id',
    element: <JobDetailPage />
  },
  {
    path: '/offres-emploi/:id',
    element: <JobDetailPage />
  },
  {
    path: '/offres-emploi/:id/postuler',
    element: <JobApplyPage />
  },
  {
    path: '/employeurs',
    element: <EmployersPage />
  },
  {
    path: '/connexion',
    element: <LoginPage />
  },
  {
    path: '/inscription-candidat',
    element: <RegisterCandidatePage />
  },
  {
    path: '/mot-de-passe-oublie',
    element: <ForgotPasswordPage />
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/candidats/inscription',
    element: <CandidateRegisterPage />
  },
  {
    path: '/inscription-employeur',
    element: <RegisterEmployerPage />
  },
  {
    path: '/employeurs/inscription',
    element: <RegisterEmployerPage />
  },
  {
    path: '/tableau-de-bord-candidat',
    element: (
      <ProtectedRoute allowedRoles={['candidate']}>
        <CandidateDashboardPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/tableau-de-bord-employeur',
    element: (
      <ProtectedRoute allowedRoles={['employer']}>
        <EmployerDashboardPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/recrutement-international',
    element: <InternationalRecruitmentPage />
  },
  {
    path: '/succursales',
    element: <BranchesPage />
  },
  {
    path: '/a-propos',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/admin/connexion',
    element: <AdminLoginPage />
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute allowedRoles={['admin']} redirectTo="/admin/connexion">
        <AdminPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/collaborateur',
    element: (
      <ProtectedRoute allowedRoles={['collaborator', 'admin']} redirectTo="/admin/connexion">
        <AdminCollabPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/aeronautique',
    element: <AeronautiquePage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:slug',
    element: <ArticlePage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;